import React from 'react';

/**
 * Piel común de las tarjetas laterales, alineada con los paneles del resto de
 * la plataforma (borde, radio y cabecera de .gn-panel).
 */
export const TarjetaPerfil = ({ icono: Icono, titulo, extra, children }) => (
  <section className="perfil-card">
    <header className="perfil-card-header">
      <span className="perfil-card-header-titulo">{Icono && <Icono />} {titulo}</span>
      {extra}
    </header>
    <div className="perfil-card-content">{children}</div>
  </section>
);

/** Placeholder de carga: mantiene la altura para que la columna no salte. */
export const Skeleton = ({ filas = 3 }) => (
  <div className="perfil-skeleton" aria-hidden="true">
    {Array.from({ length: filas }).map((_, i) => (
      <span key={i} className="perfil-skeleton-fila" />
    ))}
  </div>
);

/** Estado vacío con el mismo lenguaje que .gn-vacio. */
export const Vacio = ({ icono: Icono, children, accion }) => (
  <div className="perfil-vacio">
    {Icono && <Icono />}
    <p>{children}</p>
    {accion}
  </div>
);

export default TarjetaPerfil;
